<template>
  <div>
    <v-card
      flat
    >
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">SEARCH COOP SAVINGS PROTECT MEMBERS</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-combobox
          class="mt-6"
          :append-icon="icons.mdiAccountSearchOutline"
          v-model="search"
          @keyup="searching($event.target.value)"
          @change="get_search_items_info"
          :items="search_items"
          item-value="id"
          item-text="account_name"
          placeholder="Search by (Account Name/Account #)"
          ref="memberCombobox"
          dense
          outlined
        ></v-combobox>
      </v-card-text>
      <v-tabs
        v-model="tab"
        show-arrows
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.title"
        >
          <v-icon
            size="20"
            class="me-3"
          >
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>
      <!-- tabs item -->
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <account
            v-on:data="reset"
            :cropped="cropped"
            :branch="branch"
            :status="status"
            :date_opening="date_opening"
            :data="member_information"
          ></account>
        </v-tab-item>
        <v-tab-item>
          <foundation
            :data="foundation_history"
            :info="member_information"
          ></foundation>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
  import {
    mdiAccountOutline, mdiInformationOutline, mdiAccountCashOutline
    , mdiCash, mdiCellphone, mdiClipboardClockOutline, mdiContentSaveMoveOutline,
    mdiCashRefund, mdiShieldAccount, mdiGoogleCirclesCommunities, mdiBallotOutline
  } from '@mdi/js'
  import {mapGetters, mapActions} from "vuex";
  import Account from './coop_protek_components/Account'
  import Foundation from './coop_protek_components/Foundation'

  export default {
    components: {
      Account,
      Foundation,
    },
    setup() {
      return {
        avatarImg: require('@/assets/images/avatars/1.png'),
        icons: {
          mdiAccountOutline,
          mdiAccountCashOutline,
          mdiInformationOutline,
          mdiCash,
          mdiCellphone,
          mdiClipboardClockOutline,
          mdiContentSaveMoveOutline,
          mdiCashRefund,
          mdiShieldAccount,
          mdiGoogleCirclesCommunities,
          mdiBallotOutline,
        },
      }
    },
    data() {
      return {
        search: '',
        search_member: '',
        search_items: [],

        cropped: this.avatarImg,
        branch: '',
        status: '',
        date_opening: '',
        member_information: {},
        loans_history: [],
        gadget_loans_history: [],
        time_deposit_history: [],
        share_capital_history: [],
        mortuary_insurance_history: [],
        foundation_history: [],
        raw_lots_history: [],

        tab: '',
        loan_tab: '',
        tabs: [
          {title: 'INFORMATIONS', icon: mdiAccountOutline},
          {title: 'DATA', icon: mdiAccountCashOutline},
        ],
      }
    },
    watch: {
      search_member: function () {
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if (this.search_member === '') {
            this.search_items = []
          } else {
            this.searching_search_items(this.search_member)
          }
        }, 500)
      },
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
    },
    methods: {
      ...mapActions('coop_savings_protect_info', ['search_members_have_coop_savings_protect_data']),
      searching(value) {
        this.search_member = value
      },
      searching_search_items(value) {
        this.search_members_have_coop_savings_protect_data({
          search_word: value
        })
          .then(response => {
            this.search_items = response.data
          })
      },
      reset() {
        this.search_member = ''
        this.search_items = []
        this.cropped = this.avatarImg
        this.branch = ''
        this.member_information = {}
        this.foundation_history = []
      },
      get_search_items_info() {
        this.amount = 0
        this.amount_due = []
        if (this.search_items.length > 0) {
          var index = this.search_items.map(function (x) {
            return x.id;
          }).indexOf(this.search.id)
          if (index != -1) {
            this.cropped = this.search_items[index].member_1_valid_signature
            this.branch = this.search_items[index].branch
            this.member_information = this.search_items[index].info
            this.status = this.search_items[index].status
            this.date_opening = this.search_items[index].date_of_effective
            this.foundation_history = this.search_items[index].data
          } else {
            this.reset()
          }
        } else {
          this.reset()
        }
      },
    }
  }
</script>
